import { booleanAttribute, Directive, input } from '@angular/core';

/**
 * Adds a pending state to any `zh-btn` button.
 *
 * While `[zhLoading]` is truthy the button is disabled (blocks click AND
 * keyboard/Enter re-submit) and shows the spinner via the existing
 * `.zh-btn-loading` style. Prevents duplicate POSTs on double-submit.
 *
 *   <button class="zh-btn-accent" [appZhLoading]="isSubmitting()" (click)="submit()">Save</button>
 */
@Directive({
  selector: 'button[appZhLoading]',
  host: {
    '[class.zh-btn-loading]': 'loading()',
    '[attr.disabled]': 'loading() ? "" : null',
  },
})
export class ButtonLoadingDirective {
  readonly loading = input(false, { alias: 'appZhLoading', transform: booleanAttribute });
}
